import styles from './PageHeader.module.scss';

/** The single `<h1>` for an interior page, with an optional standfirst. */
function PageHeader({ eyebrow, title, intro }) {
  return (
    <header className={styles.header}>
      {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
      <h1 className={styles.title}>{title}</h1>
      {intro && <p className={styles.intro}>{intro}</p>}
    </header>
  );
}

export default PageHeader;
